import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getWidgetProductAnalytics = {
  name: "getWidgetProductAnalytics" as const,
  input: z.object({ startDate: z.date(), endDate: z.date() }),
  output: z.object({
    currency: createEnum(Currency),
    productAnalytics: z.array(
      z.object({
        productId: z.string(),
        productTitle: z.string(),
        imageUrl: z.string().nullable(),
        timesOffered: z.number(),
        timesAccepted: z.number(),
        conversionRate: z.number().nullable(),
        totalRevenue: z.number(),
      }),
    ),
  }),
};
